import fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchWorkflows: (category, readStatus) => fetch.useFetchDispatch(
    actions.FETCH_WORKFLOWS,
    readStatus,
    { category },
  ),
  useFetchWorkflow: ({ category, code }, readStatus, config = fetchConfig()) => fetch.useFetchDispatch(
    actions.FETCH_WORKFLOW,
    readStatus,
    { category, code },
    config,
  ),
};
